// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2QR96","error":"Textarea_error__TB6SZ","readonly":"Textarea_readonly__3sndp","disabled":"Textarea_disabled__LJ8gu"};